import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { HeroBlockComponent } from '@content/home/hero-block/hero-block.component';
import { DividerImgComponent } from '@shared/divider-img/divider-img.component';
import { BusinessGoalComponent } from '@content/home/business-goal/business-goal.component';
import { EfficientAccountingIntegrationComponent } from '@content/home/efficient-accounting-integration/efficient-accounting-integration.component';
import { ComprehensiveProcessNotificationsComponent } from '@content/home/comprehensive-process-notifications/comprehensive-process-notifications.component';
import { PainPointsAndSolutionsComponent } from '@content/home/pain-points-and-solutions/pain-points-and-solutions.component';
import { HomeFeaturesComponent } from '@content/home/home-features/home-features.component';

@Component({
    selector: 'companyid-home',
    templateUrl: './home.component.html',
    styleUrl: './home.component.scss',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        HeroBlockComponent,
        DividerImgComponent,
        BusinessGoalComponent,
        EfficientAccountingIntegrationComponent,
        ComprehensiveProcessNotificationsComponent,
        PainPointsAndSolutionsComponent,
        HomeFeaturesComponent,
    ],
})
export class HomeComponent {}
